export const API_URL = process.env.REACT_APP_BBSW_URL;
export const API_VERSION = 'v1';
export const BASE_WIDTH = 1920;
